import { atom } from "recoil";
import { IBookingsApiFilter } from "../../api/types";

export const pendingListFilterState = atom<IBookingsApiFilter | null>({
    key: 'pendingListFilterState',
    default: null
});

export const pendingListCountState = atom<number>({
    key: 'pendingListCountState',
    default: 0
})